<!-- Prompt -->
<div *ngIf="!task.noprompt">
	<div class="modal-header">
	    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.unsavedChanges}}</h3>
	</div>
	<div class="modal-body dx-form">
	    <form class="form-signin" style="max-width:400px">
	        <div class="row">
	            <div class="col-md-12">
	                <span>{{LOCALIZATION.saveAnnotationChanges}}</span>
	            </div>
	        </div>       
	    </form>
	</div>
	<div class="modal-footer">
		<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.no}}</button>
	    <button class="btn btn-primary" type="button" (click)="saveAnnotationSession()" [disabled]="inprogress">
	    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
	    	{{LOCALIZATION.yes}}
	    </button>
	</div>		
</div>

<!-- No Prompt -->
<div *ngIf="task.noprompt">
	<div class="modal-header">
	    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.unsavedChanges}}</h3>
	</div>
	<div class="modal-body dx-form">
	    <form class="form-signin" style="max-width:400px">
	        <div class="row">
	            <div class="col-md-12" >
	                <span>{{LOCALIZATION.saveAnnotationChangesOrContinue}}</span>
	            </div>
	        </div>       
	    </form>
	</div>
	<div class="modal-footer">
		<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
	    <button class="btn btn-primary" type="button" (click)="clearDirtyFlag()" [disabled]="inprogress">
	    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
	    	{{LOCALIZATION.continueNoSave}}
	    </button>
	</div>	
</div>
